"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationUtil = void 0;
const echain_math_1 = require("@igus/echain-math");
const echain_shared_articles_oo_1 = require("@igus/echain-shared-articles-oo");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const echain_shared_logging_1 = require("@igus/echain-shared-logging");
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const echain_shared_validation_1 = require("@igus/echain-shared-validation");
const EspoolConfiguration_1 = require("./EspoolConfiguration");
const echain_shared_configurations_1 = require("@igus/echain-shared-configurations");
const KonfektionierungPriceCalculator_1 = require("./articles/KonfektionierungPriceCalculator");
const echain_shared_igus_fundamentals_1 = require("@igus/echain-shared-igus-fundamentals");
const echain_product_models_1 = require("@igus/echain-product-models");
const echain_prisma_client_1 = require("@igus/echain-prisma-client");
class ConfigurationUtil {
    /**
     * Calculates the actual length ('effektive Laenge') of current chain + AE length.
     */
    static updateKetteEffektiveLaenge(kette, aes, deactivateLogging) {
        if (!kette)
            return;
        try {
            const ketteConfigurationBuilder = new echain_shared_articles_oo_1.KetteConfigurationBuilder();
            ketteConfigurationBuilder.update(kette);
            // effektiveLaengeWithAE
            if (aes && aes.count() !== 0) {
                const aeLength = aes.getCumulatedLength();
                switch (kette.serieType) {
                    case echain_shared_articles_1.KetteSerieType.eskin: {
                        const aeExcessLength = kette.getESkinAeExcessLength();
                        kette.effektiveLaengeWithAEs = echain_shared_articles_1.KetteCalculator.calcESkinEffektiveLaengeWithAE(kette.numGlieder, kette.teilung, aeLength, aeExcessLength);
                        break;
                    }
                    case echain_shared_articles_1.KetteSerieType.trxe:
                    case echain_shared_articles_1.KetteSerieType.twisterband:
                    case echain_shared_articles_1.KetteSerieType.twisterchain:
                        // do nothing since we cannot calc it
                        break;
                    case echain_shared_articles_1.KetteSerieType.triflexR:
                        if (kette.numGlieder && kette.teilung) {
                            // effektiveLaengeWithAEs is the same length as without AEs because AE is placed over last link
                            kette.effektiveLaengeWithAEs = echain_shared_articles_1.KetteCalculator.calcEffektiveLaenge(kette.numGlieder, kette.teilung);
                        }
                        break;
                    case echain_shared_articles_1.KetteSerieType.rxRohr:
                    case echain_shared_articles_1.KetteSerieType.default:
                        kette.effektiveLaengeWithAEs = echain_shared_articles_1.KetteCalculator.calcEffektiveLaengeWithAE(kette.numGlieder, kette.teilung, aeLength);
                        break;
                    case echain_shared_articles_1.KetteSerieType.rolEchain: {
                        const ketteModel = kette.toModel();
                        if (!(0, echain_shared_articles_1.isCalculateableRolEchain)(ketteModel)) {
                            throw new Error(`${this.className}.updateKetteEffektiveLaenge: rolEchain is not calculateable`);
                        }
                        kette.effektiveLaengeWithAEs = echain_shared_articles_oo_1.RolEchainCalculatorFactory.getCalculator(ketteModel).calcLaengeWithAELength(ketteModel, aeLength);
                        break;
                    }
                    default:
                        (0, echain_shared_ts_utils_1.assertUnreachable)(kette.serieType);
                }
                return;
            }
            if (!kette.effektiveLaenge) {
                throw new Error(`${this.className}.updateKetteEffektiveLaenge: kette.effektiveLaenge is undefined`);
            }
            kette.effektiveLaengeWithAEs = kette.effektiveLaenge.clone();
        }
        catch (error) {
            if (!deactivateLogging) {
                (0, echain_shared_logging_1.getLogger)().info('ConfigurationUtil', 'updateKetteEffektiveLaenge', error);
            }
        }
    }
    static updateCableLength(configurationUnion) {
        const { type, config } = (0, echain_shared_configurations_1.asTypedConfigurationUnion)(configurationUnion);
        switch (type) {
            case 'Empty':
            case 'EspoolChild':
                break;
            case 'Espool': {
                const espool = (0, echain_shared_articles_oo_1.A)(config.Espool);
                ConfigurationUtil.calcLeitungenLengthforEspool(espool, config);
                break;
            }
            case 'Kette': {
                const kette = (0, echain_shared_articles_oo_1.A)(config.Kette);
                const leitungen = echain_shared_articles_oo_1.LeitungList.fromModel(config.Leitungen);
                const isAlienConfiguration = configurationUnion.IsAlienConfiguration;
                const smartPlasticsConfig = config.SmartPlasticsConfiguration;
                ConfigurationUtil.calcLeitungenLength(kette, leitungen, smartPlasticsConfig, isAlienConfiguration);
                break;
            }
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(type);
        }
    }
    /**
     * Calculates the lengths of all current leitungen depending on kette, ae and leitung itself.
     */
    static calcLeitungenLength(chain, cables, smartPlasticsConfig, isAlienConfiguration = false) {
        if (!chain || (!cables && !smartPlasticsConfig)) {
            this.resetLeitungLengths(cables);
            return;
        }
        const chainLength = chain.getMostPreciseEffektiveLaenge();
        if (smartPlasticsConfig) {
            this.calcLeitungenLengthForSmartPlasticsCables(smartPlasticsConfig, chainLength);
        }
        cables.toArray().forEach((cable) => {
            if (isAlienConfiguration && !cable.ueberstandFestpunkt && !cable.ueberstandMitnehmer) {
                cable.leitungslaenge = chainLength;
                return;
            }
            this.calculateLengthForLeitung(cable, chain);
        });
    }
    static calcLeitungenLengthforEspool(espool, espoolConfigurationModel) {
        var _a;
        const leitungen = echain_shared_articles_oo_1.LeitungList.fromModel(espoolConfigurationModel.Leitungen);
        const espoolConfig = EspoolConfiguration_1.EspoolConfiguration.fromModel(espoolConfigurationModel);
        const linearKette = (_a = espoolConfig.getChildByPosition(echain_shared_articles_1.EspoolChainPosition.linear)) === null || _a === void 0 ? void 0 : _a.kette;
        if (!linearKette) {
            throw new Error(`${this.className}.calcLeitungenLengthforEspool linearKette for espool is not set`);
        }
        if (!espool || !leitungen) {
            this.resetLeitungLengthsEspool(espoolConfigurationModel);
            return;
        }
        leitungen.toArray().forEach((leitung) => {
            this.calculateLengthForEspoolLeitung(leitung, espool, linearKette);
            espoolConfigurationModel.Children.forEach((child) => {
                child.Leitungen.map((l) => echain_shared_articles_oo_1.Leitung.fromModel(l)).forEach((childLeitung) => {
                    if (childLeitung.entityId === leitung.entityId) {
                        childLeitung.leitungslaenge = leitung.leitungslaenge;
                        childLeitung.ueberstandMitnehmer = leitung.ueberstandMitnehmer;
                        childLeitung.ueberstandFestpunkt = leitung.ueberstandFestpunkt;
                    }
                });
            });
        });
    }
    static calcLeitungenLengthForRolEchain(rolEchainConfiguration) {
        const rolEchain = rolEchainConfiguration.Kette;
        if (!(0, echain_shared_articles_1.isCalculateableRolEchain)(rolEchain))
            return;
        const calculator = echain_shared_articles_oo_1.RolEchainCalculatorFactory.getCalculator(rolEchain);
        const leitungen = rolEchainConfiguration.Leitungen;
        const aes = echain_shared_articles_oo_1.AEList.fromModel(rolEchainConfiguration.AEs);
        const echainLengthWithAe = calculator.calcLaengeWithAEs(rolEchain, aes);
        leitungen.forEach((leitung) => {
            const ueberstandMitnehmer = echain_shared_quantities_1.Q.optional(leitung.UeberstandMitnehmer);
            const ueberstandFestpunkt = echain_shared_quantities_1.Q.optional(leitung.UeberstandFestpunkt);
            const cableLength = echain_shared_quantities_1.Q.optional(leitung.Leitungslaenge);
            if (cableLength &&
                (leitung.FesteLaenge || (0, echain_shared_articles_oo_1.A)(leitung).leitungslaengeLocked) && // leitungslaengeLocked getter on cable article checks if cable is somehow locked by cable length
                (ueberstandFestpunkt || ueberstandMitnehmer)) {
                if (ueberstandFestpunkt) {
                    leitung.UeberstandMitnehmer = echain_shared_articles_1.LeitungCalculator.calcMissingUeberstand(echainLengthWithAe, cableLength, ueberstandFestpunkt).toJson();
                }
                else {
                    leitung.UeberstandFestpunkt = echain_shared_articles_1.LeitungCalculator.calcMissingUeberstand(echainLengthWithAe, cableLength, ueberstandMitnehmer).toJson();
                }
            }
            // calc the leitungslaenge according to ueberstandFestpunkt and ueberstandMitnehmer
            else {
                if (echainLengthWithAe && ueberstandFestpunkt && ueberstandMitnehmer) {
                    leitung.Leitungslaenge = echain_shared_articles_1.LeitungCalculator.calcLeitungslaenge(echainLengthWithAe, ueberstandFestpunkt, ueberstandMitnehmer).toJson();
                }
                else {
                    leitung.Leitungslaenge = undefined;
                }
            }
        });
    }
    /**
     * Sets leitungslaenge of all leitungen to undefined if allowed
     */
    static resetLeitungLengths(leitungen) {
        leitungen
            .toArray()
            .filter((leitung) => !leitung.leitungslaengeLocked && !leitung.festeLaenge)
            .forEach((leitung) => (leitung.leitungslaenge = undefined));
    }
    /**
     * Sets leitungslaenge of all leitungen on parent and child config to undefined if allowed
     */
    static resetLeitungLengthsEspool(espoolConfigurationModel) {
        const childConfigs = espoolConfigurationModel.Children;
        const leitungen = echain_shared_articles_oo_1.LeitungList.fromModel(espoolConfigurationModel.Leitungen);
        leitungen
            .toArray()
            .filter((leitung) => !leitung.leitungslaengeLocked && !leitung.festeLaenge)
            .forEach((leitung) => (leitung.leitungslaenge = undefined));
        childConfigs.forEach((child) => child.Leitungen.map((l) => echain_shared_articles_oo_1.Leitung.fromModel(l))
            .filter((childLeitung) => !childLeitung.leitungslaengeLocked && !childLeitung.festeLaenge)
            .forEach((leitung) => (leitung.leitungslaenge = undefined)));
    }
    /**
     * Calculates the missing length property for a leitung.
     * Leitung has 3 lengths properties: ueberstandMitnehmer, ueberstandFestpunkt and leitungslaenge.
     * If 2 are set, the other can be calculated depending on current kette and ae.
     *
     * @param leitung
     * @param kette
     */
    static calculateLengthForLeitung(leitung, kette) {
        const kettenLaenge = kette.getMostPreciseEffektiveLaenge();
        const ueberstandMitnehmer = leitung.ueberstandMitnehmer;
        const ueberstandFestpunkt = leitung.ueberstandFestpunkt;
        // leitungslaenge must not be changed because
        // either the article can only be sold with a specific laenge or
        // because the user configured the laenge as fixed value
        // => we update ueberstandFestpunkt or ueberstandMitnehmer
        if (leitung.festeLaenge || leitung.leitungslaengeLocked) {
            if (kettenLaenge && leitung.leitungslaenge && (ueberstandFestpunkt || ueberstandMitnehmer)) {
                if (ueberstandFestpunkt) {
                    leitung.ueberstandMitnehmer = echain_shared_articles_1.LeitungCalculator.calcMissingUeberstand(kettenLaenge, leitung.leitungslaenge, ueberstandFestpunkt);
                }
                else {
                    leitung.ueberstandFestpunkt = echain_shared_articles_1.LeitungCalculator.calcMissingUeberstand(kettenLaenge, leitung.leitungslaenge, ueberstandMitnehmer);
                }
            }
        }
        // calc the leitungslaenge according to ueberstandFestpunkt and ueberstandMitnehmer
        else {
            if (kettenLaenge && ueberstandFestpunkt && ueberstandMitnehmer) {
                leitung.leitungslaenge = echain_shared_articles_1.LeitungCalculator.calcLeitungslaenge(kettenLaenge, ueberstandFestpunkt, ueberstandMitnehmer);
            }
            else {
                leitung.leitungslaenge = undefined;
            }
        }
    }
    static calcLeitungenLengthForSmartPlasticsCables(smartPlasticsConfig, chainLength) {
        if (!chainLength)
            return;
        const switchCabinetConfig = smartPlasticsConfig.switchCabinet;
        (0, echain_shared_ts_utils_1.getObjectKeys)(smartPlasticsConfig).forEach((key) => {
            var _a, _b;
            if (!(0, echain_product_models_1.isSmartPlasticsType)(key))
                return;
            const smartPlasticsType = key;
            switch (smartPlasticsType) {
                case echain_prisma_client_1.SmartPlasticsType.ECP: {
                    const sensorCable = (_a = smartPlasticsConfig[echain_prisma_client_1.SmartPlasticsType.ECP]) === null || _a === void 0 ? void 0 : _a.sensorCable;
                    if (!sensorCable)
                        return;
                    sensorCable.LaengeUeberstandLock = echain_shared_articles_1.LeitungslaengeUeberstandLock.laengeOnly;
                    if (switchCabinetConfig.position === echain_shared_igus_fundamentals_1.EchainEnd.fixedEnd) {
                        const sensorCableLength_m = chainLength.m + (0, echain_shared_quantities_1.Q)(switchCabinetConfig.distance).m + echain_shared_configurations_1.SWITCH_CABINET_CABLE_EXTRA_LENGTH_M;
                        sensorCable.Leitungslaenge = { Value: sensorCableLength_m, Unit: echain_shared_quantities_1.LengthUnits.m };
                        return;
                    }
                    sensorCable.Leitungslaenge = {
                        Value: (0, echain_shared_quantities_1.Q)(switchCabinetConfig.distance).m + echain_shared_configurations_1.SWITCH_CABINET_CABLE_EXTRA_LENGTH_M,
                        Unit: echain_shared_quantities_1.LengthUnits.m,
                    };
                    return;
                }
                case echain_prisma_client_1.SmartPlasticsType.ECW: {
                    const sensorCable = (_b = smartPlasticsConfig[echain_prisma_client_1.SmartPlasticsType.ECW]) === null || _b === void 0 ? void 0 : _b.sensorCable;
                    if (!sensorCable)
                        return;
                    sensorCable.LaengeUeberstandLock = echain_shared_articles_1.LeitungslaengeUeberstandLock.laengeOnly;
                    if (switchCabinetConfig.position === echain_shared_igus_fundamentals_1.EchainEnd.fixedEnd) {
                        sensorCable.Leitungslaenge = {
                            Value: (0, echain_shared_quantities_1.Q)(switchCabinetConfig.distance).m + echain_shared_configurations_1.SWITCH_CABINET_CABLE_EXTRA_LENGTH_M,
                            Unit: echain_shared_quantities_1.LengthUnits.m,
                        };
                        return;
                    }
                    const sensorCableLength_m = chainLength.m + (0, echain_shared_quantities_1.Q)(switchCabinetConfig.distance).m + echain_shared_configurations_1.SWITCH_CABINET_CABLE_EXTRA_LENGTH_M;
                    sensorCable.Leitungslaenge = { Value: sensorCableLength_m, Unit: echain_shared_quantities_1.LengthUnits.m };
                    return;
                }
                default:
                    (0, echain_shared_ts_utils_1.assertUnreachable)(smartPlasticsType);
            }
        });
    }
    /**
     * Calculates the missing length property for a leitung (except placeholder without "Ueberstaende") for a espool.
     * Leitung has 3 lengths properties: ueberstandMitnehmer, ueberstandFestpunkt and leitungslaenge.
     * If 2 are set, the other can be calculated depending on current espool.
     *
     */
    static calculateLengthForEspoolLeitung(leitung, espool, linearKette) {
        var _a, _b;
        if (leitung.isPlaceholder && !(leitung.ueberstandFestpunkt && leitung.ueberstandMitnehmer)) {
            return;
        }
        if (!espool.leitungLengthMin) {
            throw new Error(`${this.className}.calculateLengthForLeitung leitungLengthMin for espool is not set`);
        }
        // generate helper IA to get the count of it in linearKette
        const helpIa = echain_shared_articles_oo_1.IA.fromJson({
            StartingAtNthKettenglied: (_a = espool.linearKette) === null || _a === void 0 ? void 0 : _a.FixedPerNth,
            PerNthKettenglied: (_b = espool.linearKette) === null || _b === void 0 ? void 0 : _b.FixedPerNth,
        });
        const strainReliefCount = echain_shared_articles_oo_1.IaCountUtil.getCountForKette(helpIa, linearKette.toModel(), (0, echain_shared_logging_1.getLogger)()) || 0;
        if (leitung.leitungslaengeLocked) {
            if (!leitung.leitungslaenge) {
                throw new Error(`${this.className}.calculateLengthForLeitung leitungslaenge on leitung is not set`);
            }
            if (leitung.ueberstandFestpunkt) {
                leitung.ueberstandMitnehmer = echain_shared_quantities_1.Length.mm(echain_math_1.LeitungMath.calcMissingLeitungUeberstandForEspool(espool.leitungLengthMin.mm, leitung.leitungslaenge.mm, leitung.ueberstandFestpunkt.mm, espool.extraLeitungLength.mm, strainReliefCount));
            }
            else if (leitung.ueberstandMitnehmer) {
                leitung.ueberstandFestpunkt = echain_shared_quantities_1.Length.mm(echain_math_1.LeitungMath.calcMissingLeitungUeberstandForEspool(espool.leitungLengthMin.mm, leitung.leitungslaenge.mm, leitung.ueberstandMitnehmer.mm, espool.extraLeitungLength.mm, strainReliefCount));
            }
        }
        else {
            if (!leitung.ueberstandFestpunkt) {
                throw new Error(`${this.className}.calculateLengthForLeitung ueberstandFestpunkt for leitung is not set`);
            }
            if (!leitung.ueberstandMitnehmer) {
                throw new Error(`${this.className}.calculateLengthForLeitung ueberstandMitnehmer for leitung is not set`);
            }
            leitung.leitungslaenge = echain_shared_quantities_1.Length.mm(echain_math_1.LeitungMath.calcLeitungLengthforEspoolByUerberstaende(espool.leitungLengthMin.mm, leitung.ueberstandFestpunkt.mm, leitung.ueberstandMitnehmer.mm, espool.extraLeitungLength.mm, strainReliefCount));
        }
    }
    static recalcKonfektionierung(configuration, konfektionierungen, hasCustomKonfektionierungPrice) {
        konfektionierungen.clearCalculatedPrices();
        if (!hasCustomKonfektionierungPrice) {
            return KonfektionierungPriceCalculator_1.KonfektionierungPriceCalculator.calcAndUpdateAll(configuration, konfektionierungen);
        }
        return echain_shared_validation_1.Validation.empty();
    }
}
exports.ConfigurationUtil = ConfigurationUtil;
ConfigurationUtil.className = 'ConfigurationUtil';
//# sourceMappingURL=ConfigurationUtil.js.map